module.exports = __webpack_public_path__ + "7d38b8ef89792fa1be866545c45ea20e.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo.png
// module id = 548
// module chunks = 0